import { useEffect, useMemo, useState } from "react";
import { fancyBearsContract } from "config";
import { useContractRead } from "wagmi";

const useFancyBearsInWallet = (
  address?: string
): [tokenIds: number[] | undefined, readFancyBearsInWallet: () => void] => {
  const [fancyBearsInWallet, setFancyBearsInWallet] = useState<number[]>();

  const [{ data: fancyBearsInWalletData }, readFancyBearsInWallet] =
    useContractRead(
      {
        addressOrName: fancyBearsContract.address,
        contractInterface: fancyBearsContract.interface,
      },
      "tokensInWallet",
      {
        args: address,
      }
    );

  useEffect(() => {
    if (fancyBearsInWalletData) {
      setFancyBearsInWallet(
        fancyBearsInWalletData?.map((bn) => bn.toNumber() as number)
      );
    }
  }, [fancyBearsInWalletData]);

  return useMemo(
    () => [fancyBearsInWallet, readFancyBearsInWallet],
    [fancyBearsInWallet, readFancyBearsInWallet]
  );
};

export default useFancyBearsInWallet;
